import { createFileRoute } from '@tanstack/react-router';
import { BundlesPage } from '../../../features/studio/pages/bundles.tsx';

export const Route = createFileRoute('/_app/studio/')({ component: BundlesPage });
